import React, { useRef, useEffect } from "react";
import "./MenuBar.css";

function MenuButton({ children, onClick }) {
  return (
    <div className="button">
      <button className="toggle-button" onClick={onClick}>
        {children}
      </button>
    </div>
  );
}

function MenuBar() {
  const careerSectionRef = useRef(null);
  const projectSectionRef = useRef(null);
  const skillsSectionRef = useRef(null);
  const socialsSectionRef = useRef(null);

  useEffect(() => {
    careerSectionRef.current = document.getElementById("career");
    projectSectionRef.current = document.getElementById("games");
    skillsSectionRef.current = document.getElementById("skills");
    socialsSectionRef.current = document.getElementById("socials");
  }, []);

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="menubar-container">
      <div className="buttons">
        <MenuButton onClick={() => scrollToSection(skillsSectionRef)}>
          SKILLS
        </MenuButton>
        <MenuButton onClick={() => scrollToSection(projectSectionRef)}>
          PROJECTS
        </MenuButton>
        <MenuButton onClick={() => scrollToSection(careerSectionRef)}>
          CAREER
        </MenuButton>
        <MenuButton onClick={() => scrollToSection(socialsSectionRef)}>
          SOCIALS
        </MenuButton>
      </div>
    </section>
  );
}

export default MenuBar;
